/* eslint-disable import/prefer-default-export */
import mixpanel from 'mixpanel-browser';

// The value should either be replaced as late as possible for production builds
// or, during development, using environment variables (.env or docker env)
const MIXPANEL_TOKEN = process.env.MIXPANEL_TOKEN || '____MIXPANEL_TOKEN____';

// We decide if we should log to console or to MixPanel based on if token was configured
const isMixPanelConfigured = !MIXPANEL_TOKEN.includes('____');

if (!isMixPanelConfigured) {
  console.warn(
    '🍯 Development mode: Environment variable MIXPANEL_TOKEN is not defined/replaced.',
  );
}

mixpanel.init(MIXPANEL_TOKEN);

export const userMetrics = {
  identify: (id) => {
    if (isMixPanelConfigured) {
      mixpanel.identify(id);
    } else {
      console.log('Mixpanel - identify:', id);
    }
  },
  alias: (id) => {
    if (isMixPanelConfigured) {
      mixpanel.alias(id);
    } else {
      console.log('Mixpanel - alias:', id);
    }
  },
  track: (name, props) => {
    if (isMixPanelConfigured) {
      mixpanel.track(name, props);
    } else {
      console.log('Mixpanel - track:', name, props);
    }
  },
  people: {
    set: (props) => {
      if (isMixPanelConfigured) {
        mixpanel.people.set(props);
      } else {
        console.log('Mixpanel - people:', props);
      }
    },
  },
  register: (props) => {
    if (isMixPanelConfigured) {
      mixpanel.register(props);
    } else {
      console.log('Mixpanel - register:', props);
    }
  },
  register_once: (props) => {
    if (isMixPanelConfigured) {
      mixpanel.register_once(props);
    } else {
      console.log('Mixpanel - register once:', props);
    }
  },
};
